// extracted by mini-css-extract-plugin
export default {"main":"FormError_main__AMa4x"};